import type { PartialDesignBrief } from '../types/briefSchema';
import type { BriefDocument, BriefFieldValue } from '../types/chat';

function extractFieldValue(field: BriefFieldValue): unknown {
    if (field.text != null && field.text !== '') return field.text;
    if (field.choice != null && field.choice !== '') return field.choice;
    if (field.multiText != null && field.multiText.length > 0) return field.multiText;
    if (field.multiChoice != null && field.multiChoice.length > 0) return field.multiChoice;
    if (field.date != null && field.date !== '') return field.date;
    if (field.integer != null) return field.integer;
    if (field.boolean != null) return field.boolean;
    return undefined;
}

export function mapDocumentToBrief(document: BriefDocument): Partial<PartialDesignBrief> {
    const patch: Record<string, unknown> = {};

    for (const field of document.values) {
        const value = extractFieldValue(field);
        if (value !== undefined) {
            patch[field.key] = value;
        }
    }

    return patch as Partial<PartialDesignBrief>;
}
